'use client';

import useFeatures from '@alltrails/features/hooks/useFeatures';
import { useIntl } from 'react-intl';
import { getFormattedHoursMinutesWithUnitsInSpans } from '@alltrails/data-formatting';
import styles from './TrailStats.module.scss';

type TrailStatsProps = {
  durationMinutes: string;
  averageTimeToComplete?: {
    value: string;
    unit: string;
  };
  preventResize?: boolean;
};

const Duration = ({ durationMinutes, averageTimeToComplete, preventResize }: TrailStatsProps) => {
  const intl = useIntl();
  const features = useFeatures();

  const isRoundEstTimeToCompletionEnabled = features?.includes('round_est_time_completion');

  const statValueClass = preventResize ? styles.statValueSm : styles.statValue;
  return (
    <div className={styles.stat}>
      {isRoundEstTimeToCompletionEnabled && averageTimeToComplete ? (
        <span className={statValueClass}>
          {averageTimeToComplete.value}
          <span>{averageTimeToComplete.unit}</span>
        </span>
      ) : (
        <span className={statValueClass}>{getFormattedHoursMinutesWithUnitsInSpans(intl, parseInt(durationMinutes) * 60, false)}</span>
      )}
      <span className={styles.statLabel}>{intl.formatMessage({ defaultMessage: 'Estimated time' })}</span>
    </div>
  );
};

export default Duration;
